import type { CompanyReportSection } from '@/pages/CompanyReport/useSection';
import { useCompanyCanonicalUrl } from '@/hooks/useCompany';
import useCompanyStatementsAPIFormatted from '@/hooks/useCompanyStatementsAPIFormatted';

//This hook returns the introduction sentences as part of this initiative here:
//https://simplywallst.atlassian.net/wiki/spaces/shibainu/pages/1375273032
function useIntroSentence(section?: CompanyReportSection): string {
  const canonicalUrl = useCompanyCanonicalUrl();
  const { data: statements } = useCompanyStatementsAPIFormatted({
    canonicalURL: canonicalUrl,
  });
  const {
    IsGoodHealthIntro: isGoodHealthIntro,
    IsFruitfulPastIntro: isFruitfulPastIntro,
    IsFruitfulFutureIntro: isFruitfulFutureIntro,
    HasManagementInformationIntro: hasManagementInformationIntro,
    IsFruitfulDividendIntro: isFruitfulDividendIntro,
  } = statements || {};

  switch (section) {
    case 'past':
      return isFruitfulPastIntro?.description || '';
    case 'health':
      return isGoodHealthIntro?.description || '';
    case 'dividend':
      return isFruitfulDividendIntro?.description || '';
    case 'future':
      return isFruitfulFutureIntro?.description || '';
    case 'management':
      return hasManagementInformationIntro?.description || '';
    default:
      return '';
  }
}
export default useIntroSentence;
